<template>
  <div class="container">
    <div class="info">
      <div class="title">{{ $t('user').Avatarchange }}</div>
      <div class="head">
        <van-uploader class="img-box" preview-size="120" :preview-image="false" :after-read="justAfterRead">
          <img v-if="userInfo.avatar" :src="baseUrl + userInfo.avatar" />
          <img v-else src="@/assets/img/heard.png" />
        </van-uploader>
      </div>
      <!-- 按钮 -->
      <van-button block @click="handleSub">{{ $t('public').confirm }}</van-button>
    </div>
  </div>
</template>

<script>
import systemApi from '@/api/system'
import userApi from '@/api/user'
export default {
  components: {
  },
  data() {
    return {
      baseUrl: window.baseURL,
      userInfo: {},
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getMemberInfo()
  },
  methods: {
    // 获取用户信息
    async getMemberInfo() {
      const res = await userApi.getMemberInfo()
      this.userInfo = res.user
    },
    //上传头像
    async justAfterRead(file) {
      const formdata = new FormData()
      formdata.append('file', file.file)
      var res = await systemApi.UploadFile(formdata)
      this.userInfo.avatar = res.fileName
    },
    //提交
    async handleSub() {
      //更改头像
      await userApi.upMemberAvatar({ avatar: this.userInfo.avatar })
      this.$toast(this.$t('user').Replacesuccessfully)
      this.$router.go(-1)
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 80px;
  width: 100%;
  background: var(--background_color);

  .info {
    margin: 0 auto;
    max-width: 480px;
    border-radius: 15px;
    padding: 30px;
    background: var(--info_color);

    .title {
      font-size: 48px;
      font-weight: bold;
      color: var(--text_color);
    }

    .head {
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        margin: 80px 0;
        width: 210px;
        height: 210px;
        border-radius: 50%;
      }
    }

    .van-button {
      background: var(--text_color);
      height: 50px;
      border-radius: 25px;
      border: 0;
      font-size: 15px;
      color: var(--background_color);
    }

    .van-button:hover {
      opacity: 0.8;
    }
  }

}
</style>
